<template>
  <file-grid 
    v-if="bcFileStore.view === 'grid'" 
    :list="bcFileStore.list" 
    :loading="false" 
    v-aw-driver-element="'ComponentFileGrid'"
  />
  <file-table 
    v-if="bcFileStore.view === 'table'" 
    :list="bcFileStore.list" 
    :loading="bcFileStore.loading" 
    v-aw-driver-element="'ComponentFileGrid'"
  />
  <file-grid 
    v-if="bcFileStore.view === 'grid'" 
    :list="[]" 
    :loading="bcFileStore.loading" 
  />
  <div ref="loadMoreEl">&nbsp;</div>
</template>
<script>
import { mapStores } from 'pinia'
import useBcFileStore from '@/frontapp/store/bcFile'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { ref, watch } from 'vue'
import { useElementVisibility } from '@vueuse/core'
import EditFile from '../../mixins/actions/EditFile'
import { useRoute } from 'vue-router'

export default {
  props: [],
  setup () {
    const loadMoreEl = ref(null)
    const loadMoreElIsVisible = useElementVisibility(loadMoreEl)
    const bcFileStore = useBcFileStore()
    const route = useRoute()
    bcFileStore.showDeleted(route.matched[0].name === 'BCTrashFile')
    bcFileStore.showModalSearch(false)

    if (bcFileStore.list.length === 0) {
      bcFileStore.loadFiles()
    }
    
    watch(() => bcFileStore.q, () => {
      bcFileStore.list = []
      bcFileStore.offset = 0
      bcFileStore.loadFiles()
    })

    watch(loadMoreElIsVisible, (newVal, oldVal) => {
      if (bcFileStore.loading === false && oldVal === false && newVal === true) {
        bcFileStore.offset += bcFileStore.limit
        bcFileStore.loadFiles()
      }
    })

    return {
      loadMoreEl
    }
  },
  computed: {
    ...mapStores(useBcFileStore, useBcSelectedStore),
  },
  mounted() {
    this.bcSelectedStore.reset(null, 'id', null, false)
  },
  watch: {
    $route: {
      handler(to) {
        if (['BCFile','BCTrashFile'].includes(to.matched[0].name) && to.params.id) {
          EditFile(this.$store, this.$formValues, to.params.id)
        }
      },
      immediate: true
    }
  },
}
</script>
